'use client';

import React, { useState, useEffect } from 'react';
import BannerSlider from './BannerSlider';
import { BannerSkeleton } from './BannerSkeleton'; // Import your existing skeleton
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { API_HOME_THINGS } from '@/constant/apiRout';

export default function Banner() {
  const { data, isLoading } = useFetcherCSR(API_HOME_THINGS);
  const [isMobile, setIsMobile] = useState(false);
  const desktopSlider = data?.sliders;
  const mobileSlider = data?.mobile_sliders;

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    setIsMobile(isMobile);
  }, []);

  // --- RENDER LOGIC ---

  // 1. While fetching, show the skeleton component.
  if (isLoading) {
    return <BannerSkeleton />;
  }

  // 3. Once data is available, render the full banner with the slider.
  return (
    <section className="banner padding-top--style3">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <BannerSlider sliders={isMobile ? mobileSlider : desktopSlider} />
          </div>
        </div>
      </div>
    </section>
  );
}
